<script>
import {onMount} from 'svelte';
import { FirstTimeLoginAsset } from './features';
import AssetViewer from './AssetViewer.svelte';
import { fade } from 'svelte/transition';

const StorageKey = 'FirstTimeViewed';

let asset;

onMount(() => {
  const show = FirstTimeLoginAsset && !localStorage.getItem(StorageKey);
  if (show) {
    asset = FirstTimeLoginAsset;
  }
})

function dismiss() {
  asset = undefined;
  localStorage.setItem(StorageKey, "1")
}
</script>

{#if asset}
  <div class="modal" on:click={dismiss} out:fade>
    <div class="container">
      <AssetViewer {asset} />

      <div class="button skip" on:click={dismiss}>SKIP</div>
    </div>
  </div>
{/if}

<style>
.container {
  position: relative;
  padding: 8px;
  border-radius: 5px;
  background-color: white;
}

.skip {
  position: absolute;
  top: 24px;
  right: 24px;
}
</style>